// The page-level gate for live-on-2.0 lookups, kept free of server-only
// imports so a client bundle (the legacy _app's LiveOnV2CheckProvider) can
// use it. getServerSideProps callers import it from here too; the redirects
// in ./redirect-if-live-on-v2.ts are server-only.

import type { CommonServerSideProps } from 'shared/utils/auth/server'

import { shouldCheckRedirect } from './redirect.helper'

export type RedirectCommonProps = Pick<
  CommonServerSideProps,
  'sessionData' | 'userOrgData' | 'treatments'
>

/**
 * Whether a page should look up live-on-2.0 state at all for this caller:
 * the `migrate_projects_to_v2` flag is on and the caller is not a workspace
 * admin or super admin. Pages that gate per row (the global task list) pass
 * this down as one prop instead of re-deriving the flag and role client-side;
 * deeper trees read it through ./live-on-v2-check-context.tsx.
 */
export function shouldCheckLiveOnV2(commonProps: RedirectCommonProps): boolean {
  return shouldCheckRedirect(toGateArgs(commonProps))
}

/** The flag and role the gate reads: session member role first, then org role. */
export function toGateArgs(commonProps: RedirectCommonProps) {
  return {
    treatments: commonProps.treatments,
    role:
      commonProps.sessionData?.member?.role ?? commonProps.userOrgData?.role,
  }
}
